<template>
        <div>
            <div class="wrapper">
                <pdf
                    id="pdf"
                    v-if="decodedFile!=null"
                    :src="decodedFile"
                    :page="displayedPage"
                    :resize="true"
                    @numpages="pageCount = $event"
                ></pdf>
            </div>
        </div>
</template>

<script>

import pdf from 'pdfvuer'

export default {
    name:"PdfViewer",
    methods: {
        async updateDisplayedPage() {
            // Utilisation d'un timer afin de fluidifier la navigation rapide entre les pages
            window.clearTimeout(this.timer);
            this.timer = await window.setTimeout(() => {
                this.displayedPage = this.currentPage;
            }, "200")
        },
    },
    props: {
        courseFile: String, 
        page: Number, 
    },
    components: {
        pdf
    },
    data() {
        return {
            currentPage: this.page,
            pageCount: 0,
            decodedFile: "",
            timer: null,
            displayedPage: this.page
        }
    },
    watch: {
        courseFile: function() {
            this.currentPage = 1
        },
        page: function() {
            this.currentPage = this.page
        },
        currentPage: function() {
            this.updateDisplayedPage()
        },
        pageCount: function() {
            this.$parent.pageCount = this.pageCount;
        },
    },
    beforeMount() {
        this.decodedFile = `data:application/pdf;base64, ${this.courseFile}`
    },
}

</script>

<style scoped>
.wrapper{
    height: fit-content;
    overflow-y: auto;
	overflow-x: hidden;
    border: solid 0.5px #333;
}
#pdf {
    overflow: hidden;
}
</style>